module.exports = __webpack_public_path__ + "media/images/features/modification/thumb-voice-1-64567af2811e402ccc20cf373c3abd56.jpg";